// src/firebase.ts
import { initializeApp, FirebaseApp } from 'firebase/app'; // FirebaseApp 型をインポート
import { getAuth, Auth } from 'firebase/auth'; // Auth 型をインポート
import { getFirestore, Firestore } from 'firebase/firestore'; // Firestore 型をインポート
import { getAnalytics, Analytics } from "firebase/analytics"; // Analytics 型をインポート


// Firebase設定
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Firebase初期化
const app: FirebaseApp = initializeApp(firebaseConfig);

// サービスのエクスポートに型を明示
const auth: Auth = getAuth(app);
const db: Firestore = getFirestore(app);
const analytics: Analytics = getAnalytics(app);


export { app, auth, db, analytics };
export const appId: string = 'quiza-app';